export default __webpack_public_path__ + "static/media/image.fe5455ad.jpg";